import { useEffect, useState } from "react";
import { toast, Toaster } from "sonner";
import { api, formatApiError } from "@/lib/api";
import { Save } from "lucide-react";

const SOCIAL_FIELDS = [
  { key: "twitter", label: "X / Twitter", placeholder: "https://twitter.com/…" },
  { key: "instagram", label: "Instagram", placeholder: "https://instagram.com/…" },
  { key: "linkedin", label: "LinkedIn", placeholder: "https://linkedin.com/in/…" },
  { key: "youtube", label: "YouTube", placeholder: "https://youtube.com/@…" },
  { key: "tiktok", label: "TikTok", placeholder: "https://tiktok.com/@…" },
  { key: "email", label: "البريد الإلكتروني", placeholder: "name@domain.com" },
  { key: "website", label: "الموقع الرسمي", placeholder: "https://…" },
];

const AdminSocial = () => {
  const [data, setData] = useState(null);
  const [saving, setSaving] = useState(false);

  const load = async () => {
    try {
      const { data } = await api.get("/admin/settings");
      setData(data);
    } catch (e) { toast.error(formatApiError(e)); }
  };

  useEffect(() => { load(); }, []);

  const update = (key, val) => setData((d) => ({ ...d, social: { ...d.social, [key]: val } }));
  const toggle = (key) => setData((d) => ({ ...d, social_visibility: { ...d.social_visibility, [key]: !d.social_visibility[key] } }));

  const onSave = async (e) => {
    e.preventDefault();
    setSaving(true);
    try {
      await api.put("/admin/settings", { social: data.social, social_visibility: data.social_visibility });
      toast.success("تم الحفظ");
    } catch (err) { toast.error(formatApiError(err)); }
    finally { setSaving(false); }
  };

  if (!data) return <div className="overline animate-pulse">…</div>;

  return (
    <div data-testid="admin-social">
      <Toaster position="top-left" theme="dark" richColors />
      <div className="overline mb-3">روابط التواصل</div>
      <h1 className="font-arabic font-black text-3xl sm:text-4xl text-bone mb-10">روابط التواصل الاجتماعي</h1>

      <form onSubmit={onSave} className="space-y-6 max-w-3xl">
        {SOCIAL_FIELDS.map((f) => (
          <div key={f.key} className="grid grid-cols-1 md:grid-cols-[1fr_auto] gap-3 items-end border border-white/10 bg-ink-soft p-5">
            <label className="block">
              <span className="block mb-2 text-xs tracking-[0.2em] uppercase text-white/50 font-arabic">{f.label}</span>
              <input
                type="text"
                value={data.social[f.key] || ""}
                onChange={(e) => update(f.key, e.target.value)}
                placeholder={f.placeholder}
                className="editorial-input"
                dir="ltr"
                data-testid={`social-input-${f.key}`}
              />
            </label>
            <label className="flex items-center gap-3 text-sm font-arabic md:mb-3">
              <input type="checkbox" checked={!!data.social_visibility[f.key]} onChange={() => toggle(f.key)} className="accent-gold" data-testid={`social-toggle-${f.key}`} />
              ظاهر
            </label>
          </div>
        ))}

        <button type="submit" disabled={saving} className="btn-gold disabled:opacity-60" data-testid="social-save"><Save size={14} />{saving ? "جاري الحفظ…" : "حفظ"}</button>
      </form>
    </div>
  );
};

export default AdminSocial;
